import { useEditor, useNode } from '@craftjs/core';
import { SelectField } from '@/components/dropdowns/SelectField/SelectField';
import { SelectItem } from '@/components/ui/select';
import type { TextProps } from '@builder4/shared/components/Text';
import { STYLE_TYPOGRAPHY_VARIANTS } from '@builder4/shared/utils/constants';
import type { TypographyVariantProps } from '@builder4/shared/styles/typographyVariants';

const NodeGlobalStyleSettings = () => {
  const { actions } = useEditor();
  const { selectedStyleVariant, id } = useNode((node) => ({
    selectedStyleVariant: node.data.props.selectedStyleVariant,
    id: node.id,
  }));

  const handleValueChange = (value: string) => {
    if (value in STYLE_TYPOGRAPHY_VARIANTS) {
      actions.setProp(id, (props: Partial<TextProps>) => {
        props.selectedStyleVariant = value as TypographyVariantProps['variant'];
      });
    }
  };

  return (
    <SelectField
      onValueChange={handleValueChange}
      defaultValue={selectedStyleVariant}
      className="max-w-[216px]"
      size="small"
      text="Type"
    >
      {Object.entries(STYLE_TYPOGRAPHY_VARIANTS).map(([key, label]) => (
        <SelectItem key={key} value={key}>
          {label}
        </SelectItem>
      ))}
    </SelectField>
  );
};

export default NodeGlobalStyleSettings;
